import PageHeader from "@/components/PageHeader";
import { MOCK_NOTIFICATIONS, formatTimeFromNow } from "@/lib/mockData";
import { Bell, Check, X, Star, UserPlus, AlertCircle } from "lucide-react";

const ICON = {
  invite_accepted: UserPlus,
  spot_opened: Bell,
  commit_check: AlertCircle,
  auto_cancelled: X,
  post_activity_checkin: Star,
  nearby_invite: Bell,
};

const BG = {
  invite_accepted: "#C8E6C9",
  spot_opened: "#FFCC00",
  commit_check: "#FFCC00",
  auto_cancelled: "#FF6A2C",
  post_activity_checkin: "#FFFBEB",
  nearby_invite: "#FFFBEB",
};

const Notifications = () => {
  return (
    <div data-testid="notifications-page">
      <PageHeader title="Notifications" subtitle="In-app updates" />
      <div className="space-y-3">
        {MOCK_NOTIFICATIONS.map((n) => {
          const Icon = ICON[n.type] || Bell;
          return (
            <div
              key={n.id}
              className={`brutal-card p-4 flex gap-3 items-start ${n.unread ? "" : "opacity-70"}`}
              data-testid={`notification-${n.id}`}
            >
              <div className="w-10 h-10 brutal-border rounded-lg flex items-center justify-center shrink-0" style={{ background: BG[n.type] || "#fff" }}>
                <Icon className="w-4 h-4" strokeWidth={2.5} />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="font-bold text-sm">{n.title}</h3>
                  <span className="text-[10px] text-[#555555] font-mono shrink-0">{formatTimeFromNow(n.iso)}</span>
                </div>
                <p className="text-xs text-[#555555] mt-0.5">{n.body}</p>
                {n.type === "commit_check" && (
                  <div className="flex gap-2 mt-3">
                    <button className="brutal-btn bg-[#FF6A2C] text-white px-3 py-1.5 text-xs flex items-center gap-1" data-testid={`commit-confirm-${n.id}`}>
                      <Check className="w-3 h-3" /> Still in
                    </button>
                    <button className="brutal-btn bg-white px-3 py-1.5 text-xs flex items-center gap-1" data-testid={`commit-cancel-${n.id}`}>
                      <X className="w-3 h-3" /> Can't make it
                    </button>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Notifications;
